import rootService from 'core/services.root';

export default rootService({
    deleteOffice: ['DELETE', '/office/delete/:id'],
    fetchOfficePage: ['GET', '/office/all/paginated'],
    getOffice: ['GET', '/office/:id'],
    getOfficesList: ['GET', '/office/all'],
    postOffice: ['POST', '/office/store'],
    putOffice: ['PUT', '/office/update/:id'],
    restoreOffice: ['PUT', '/office/restore/:id']
});
